module.exports = __webpack_public_path__ + "static/img/HU.c46725b4.svg";